module.exports = function getResource(label, vars = []) {
    let resources = {
        headText: 'Chat with Customer Service',
        available: 'Available',
        unavailable: 'Chat is unavailable',
        inHours: 'All agents are busy',
        offline: 'We are offline',
        headTextAlt: 'Customer Service Chat'
    };

    return resources[label];
};
